import React from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { Warning } from '@mui/icons-material';

const PopupMenorIdade = ({
  showPopupMenorIdade,
  setShowPopupMenorIdade,
  setIsNewUser,
  setUser,
  initialValues,
}) => (
  <Dialog
    open={showPopupMenorIdade}
    onClose={() => {}}
    maxWidth='sm'
    fullWidth
  >
    <DialogTitle>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main' }}>
        <Warning color='error' />
        Cadastro não permitido
      </Box>
    </DialogTitle>
    <DialogContent>
      <Alert severity='error' sx={{ mb: 2 }}>
        Você precisa de um responsável legal para realizar este cadastro.
      </Alert>
      <Typography paragraph>
        Por favor, solicite que seu responsável (pai, mãe ou tutor) faça o
        cadastro por você.
      </Typography>
      <Typography variant='subtitle1' fontWeight='bold' gutterBottom>
        O responsável deve:
      </Typography>
      <List dense>
        <ListItem>
          <ListItemText primary='1. Ter 18 anos ou mais' />
        </ListItem>
        <ListItem>
          <ListItemText primary='2. Criar cadastro próprio (se não tiver)' />
        </ListItem>
        <ListItem>
          <ListItemText primary='3. Fazer login no sistema' />
        </ListItem>
        <ListItem>
          <ListItemText primary="4. Escolher 'Cadastrar um menor'" />
        </ListItem>
      </List>
    </DialogContent>
    <DialogActions>
      <Button
        variant='contained'
        onClick={() => {
          setShowPopupMenorIdade(false);
          setIsNewUser(false);
          setUser(initialValues);
        }}
      >
        Entendi
      </Button>
    </DialogActions>
  </Dialog>
);

export default PopupMenorIdade;
